import { render } from "./CustomerFavorites.vue?vue&type=template&id=2ef011ed"
import script from "./CustomerFavorites.vue?vue&type=script&lang=js"
export * from "./CustomerFavorites.vue?vue&type=script&lang=js"

import "./CustomerFavorites.vue?vue&type=style&index=0&id=2ef011ed&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__